import { useTheme } from '../../context/ThemeContext';
import Dashboard from './Dashboard';
import DashboardSimple from './DashboardSimple';

/**
 * Dashboard Wrapper Component
 * Conditionally renders Simple or Box dashboard based on user preference
 */
export default function DashboardWrapper() {
  const { dashboardStyle } = useTheme();

  // Simple is default
  if (dashboardStyle === 'box') {
    return <Dashboard />;
  }

  return <DashboardSimple />;
}
